import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { waLink } from "@/lib/site-config";

const STORAGE_KEY = "tn-wa-collapsed";

const FloatingWhatsApp = () => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(STORAGE_KEY) === "1") setCollapsed(true);
  }, []);

  const toggle = (val) => {
    setCollapsed(val);
    try {
      if (val) localStorage.setItem(STORAGE_KEY, "1");
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore storage errors */
    }
  };

  return (
    <div className="fixed z-40 bottom-24 md:bottom-6 right-4 md:right-6" data-testid="floating-whatsapp-wrapper">
      <AnimatePresence mode="wait" initial={false}>
        {collapsed ? (
          <motion.button
            key="collapsed"
            onClick={() => toggle(false)}
            initial={{ opacity: 0, scale: 0.6, x: 20 }}
            animate={{ opacity: 1, scale: 1, x: 0 }}
            exit={{ opacity: 0, scale: 0.6, x: 20 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            className="pulse-ring w-11 h-11 rounded-full bg-[#25D366] hover:bg-[#20bd5a] flex items-center justify-center shadow-xl shadow-emerald-900/25"
            aria-label="WhatsApp Button einblenden"
            data-testid="floating-whatsapp-collapsed"
          >
            <MessageCircle className="text-white" size={18} />
          </motion.button>
        ) : (
          <motion.div
            key="expanded"
            initial={{ opacity: 0, scale: 0.6, x: 20 }}
            animate={{ opacity: 1, scale: 1, x: 0 }}
            exit={{ opacity: 0, scale: 0.6, x: 20 }}
            transition={{ type: "spring", stiffness: 240, damping: 22 }}
            className="relative"
          >
            <motion.a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.06 }}
              whileTap={{ scale: 0.94 }}
              className="pulse-ring w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#20bd5a] flex items-center justify-center shadow-2xl shadow-emerald-900/30"
              aria-label="WhatsApp Chat starten"
              data-testid="floating-whatsapp"
            >
              <MessageCircle className="text-white" size={26} />
            </motion.a>

            <button
              onClick={(e) => {
                e.stopPropagation();
                toggle(true);
              }}
              className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-[#3A4230] hover:bg-[#2C3020] border border-white/25 flex items-center justify-center shadow-md transition-colors"
              aria-label="WhatsApp Button minimieren"
              data-testid="floating-whatsapp-minimize"
            >
              <X className="text-[#F3F1E8]" size={11} strokeWidth={2.5} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FloatingWhatsApp;
